import React, { useRef, useState } from 'react';
import { message, Modal } from 'antd';
import Loader from '../Loader'
import {Container,ModalButton} from './styles';
import {useHistory} from 'react-router-dom';
import {db} from '../../config/fire.js';


const JoinMeetingModal = (props) => {
    const [id, setid] = useState('');
    const btnref = useRef();
    let history = useHistory();
    const [load, setload] = useState(false);

    const [error, seterror] = useState('');
    const erkey = 'error';
    
    
    function handleInputChange(event) {
        setid(event.target.value);
        if(id !== '' && error === 'Type Something Bro'){
            
                seterror('')
            
            
        }
    }
    function join(id){
        
        if(id === ''){
            seterror('Type Something Bro');
            return;
        }
        setload(true);
        seterror('')
        btnref.current.disabled = true;

        console.log('https://project5-frontend.netlify.app/room/'.length);
        
        var sliced = id;
    
        if(sliced.includes("https")){
            if(sliced.length < 43){
                seterror('The Link is Broken Check Again')
                btnref.current.disabled = false;
                setload(false);
                return;
            }
            sliced = sliced.slice(43, id.length)

        }
        

            const roomref = db().ref('all-rooms/'+sliced);

            try{
            roomref.once('value', snapshot =>{
                if(snapshot.exists()){
                    const data = snapshot.val();
                    if(data.status === 'PEND'){
                        seterror("The Meeting is Not Started Yet");
                        setload(false);
                        btnref.current.disabled = false;
                        return;
                    }
                    else if(data.status === 'ACTIVE'){
                        seterror('');
                        history.push({
                            pathname: "/room/"+sliced,

                        })

                    }

                }
                else{
                    if(id.includes('https')){
                        message.error({
                            content: 'Recheck the Link is Correct',
                            duration: [2],
                            key: erkey,
                        })
                    }
                    seterror("There is No Meeting You're Looking For...");
                    setload(false);
                    btnref.current.disabled = false;
                    return;
                }

            });
        }
        catch(error){
            setload(false);
            seterror("Somethinng Problem");
            btnref.current.disabled = false;
        }
    
            
    }

    return (
        <>
            <Modal
                visible={props.visibility}
                onCancel={props.onClose}
                width={450}
                footer={null}
                centered
                >
                <Container>
                  {/* {load ? <Loader /> : <> */}
                    <input type='text' onChange={handleInputChange} placeholder='Enter your meeting id' className='input-id' value={id}/>
                    <ModalButton ref={btnref} onClick={() => join(id)}>{load ? 'Loading..' : 'Join now'}</ModalButton>
                    {error ? <strong> <p className="text-danger">{error}</p></strong> : null}
                 {/* </> } */}
                </Container>
            </Modal>
        </>
    );
};

export default JoinMeetingModal;